import NetxQueryClient, {
	type SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {getResponseResults} from '@netx/core-next/utils/api';
import {type IAttributeVocabulary} from '../schema';

/**
 * `exportAttributeVocabularyCSV` request params
 * (what is used to send to server)
 */

export type ExportAttributeVocabularyCSVRequestOptions = {
	id: number;
};

/**
 * `exportAttributeVocabularyCSV` request
 * (what gets sent to the server)
 */
export type ExportAttributeVocabularyCSVRequest = [number];

/**
 * `exportAttributeVocabularyCSV` response
 * (what comes back from the server)
 */
export type ExportAttributeVocabularyCSVResponse =
	SuccessResponse<ExportAttributeVocabularyCSVResult>;

/**
 * `exportAttributeVocabularyCSV` result
 * (what is utilized from the server response)
 */
export type ExportAttributeVocabularyCSVResult = string;

export const exportAttributeVocabularyCSVEndpoint =
	'exportAttributeVocabularyCSV';

/**
 * Export attribute vocabulary CSV
 * @param fetchParams Fetch params
 * @param signal Abort signal

 */
export const exportAttributeVocabularyCSV = async ({
	id,
}: ExportAttributeVocabularyCSVRequestOptions): Promise<ExportAttributeVocabularyCSVResult> => {
	const client = NetxQueryClient();

	const requestParams: ExportAttributeVocabularyCSVRequest = [id];

	return client
		.post<ExportAttributeVocabularyCSVResponse>(
			exportAttributeVocabularyCSVEndpoint,
			requestParams,
			{},
		)
		.then(getResponseResults);
};

export default exportAttributeVocabularyCSV;
